// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutMe_wrapper__p4tbC","logo":"AboutMe_logo__vapdg","text":"AboutMe_text__eBgP8"};